
// DO NOT CHECK IN THIS FILE. IT IS GENERATED AUTOMATICALLY USING NPM RUN FEATURE-FLAGS
import { IFeatureConfig } from '../feature-config-model';

export const Features: IFeatureConfig = {
  AllowLeadsToUpload: false,
  LogAttemptsViaConversation: false
};
